import React, { FC, useMemo } from 'react';
import { FormCol, FormRow, PasswordControl, useScopedSelector, ValidationMessage } from 'ia-react-core';
import { useTranslation } from 'react-i18next';

export interface ConfirmPasswordInputProps {

}
const ConfirmPasswordInput: FC<ConfirmPasswordInputProps> = () => {
  const { t } = useTranslation('ChangePasswordSection');
  const password: string = useScopedSelector('ChangePasswordFormValues.password');
  const validatorsConfirm = useMemo(() => ({
    isEqualToPassword: (value: string) => (value === '' || value === null || password === '' || password === null || value === password),
  }), [password]);
  return (
    <FormRow>
      <FormCol label={t('ConfirmPassword')} labelMarginBottom={36} width={100}>
        <PasswordControl
          maxLength={63}
          name="confirmpassword"
          required
          hidePasswordOnBlur
          validators={validatorsConfirm}
          validationMessages={{ isEqualToPassword: t('PasswordConfirmation') }}
        />
        <ValidationMessage type="required">{t('PasswordConfirmationRequired')}</ValidationMessage>
      </FormCol>
    </FormRow>
  );
};
export default ConfirmPasswordInput;
